/**
 * Cache Buster Script
 * Forces browsers to reload the site when a new version is deployed
 */
(function() {
  // Change this version number whenever you want to force a refresh
  // Using timestamp to ensure uniqueness across deployments
  const CURRENT_VERSION = "1.0.1_" + new Date().toISOString().slice(0, 10);
  
  // Check if we have a stored version
  const storedVersion = localStorage.getItem("site_version");
  
  // Function to unregister service workers (if any)
  const unregisterServiceWorkers = async () => {
    if ("serviceWorker" in navigator) {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          await registration.unregister();
          console.log("Service worker unregistered");
        }
      } catch (error) {
        console.error("Error unregistering service worker:", error);
      }
    }
  };

  // Function to clear all caches
  const clearCaches = async () => {
    if ("caches" in window) {
      try {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames.map(cacheName => {
            return caches.delete(cacheName);
          })
        );
        console.log("All caches cleared");
      } catch (error) {
        console.error("Error clearing caches:", error);
      }
    }
  };

  // If no version is stored or the version is different, reload and update
  if (!storedVersion || storedVersion !== CURRENT_VERSION) {
    localStorage.setItem("site_version", CURRENT_VERSION);
    
    // Only reload if there was a previous version (not first visit)
    if (storedVersion) {
      console.log("Version changed from " + storedVersion + " to " + CURRENT_VERSION);
      
      // Clear all browser storage
      try {
        // Clear localStorage (except our version)
        const versionValue = localStorage.getItem("site_version");
        localStorage.clear();
        localStorage.setItem("site_version", versionValue);
        
        // Clear sessionStorage
        sessionStorage.clear();
        
        // Unregister service workers and clear caches
        Promise.all([unregisterServiceWorkers(), clearCaches()]).then(() => {
          // Force reload from server, bypassing cache
          window.location.reload(true);
        });
      } catch (e) {
        console.error("Error during cache clearing:", e);
        // Fallback to simple reload
        window.location.reload(true);
      }
    }
  }
})();
